import BaseComponent from "../../../baseComponent";
import WidgetService from "../../../../core/services/widgetService";

import {data} from "./data";

export default class MapWidget extends BaseComponent {
  constructor(props) {
    super(props);
    this.data = [{
      "type": "Feature",
      "properties": {
        "mag": 2.64,
        "place": "9km NE of Aguanga, CA",
        "time": 1507640498050,
        "updated": 1507640719297,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38022512",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38022512.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 107,
        "net": "ci",
        "code": "38022512",
        "ids": ",ci38022512,",
        "sources": ",ci,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 88,
        "dmin": 0.01288,
        "rms": 0.21,
        "gap": 31,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 9km NE of Aguanga, CA"
      },
      "geometry": {"type": "Point", "coordinates": [-116.7966667, 33.4998333, 5.03]},
      "id": "ci38022512"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.5,
        "place": "83km S of Homer, Alaska",
        "time": 1507636274151,
        "updated": 1507637065982,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak17004820",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak17004820.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 188,
        "net": "ak",
        "code": "17004820",
        "ids": ",ak17004820,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.59,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.5 - 83km S of Homer, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-151.4581, 58.8954, 24.3]},
      "id": "ak17004820"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.9,
        "place": "34km ESE of Hana, Hawaii",
        "time": 1507632778640,
        "updated": 1507633123550,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61939531",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61939531.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 129,
        "net": "hv",
        "code": "61939531",
        "ids": ",hv61939531,",
        "sources": ",hv,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 53,
        "dmin": 0.4625,
        "rms": 0.21,
        "gap": 312,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 34km ESE of Hana, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.7093353, 20.5856667, 4.03]},
      "id": "hv61939531"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.9,
        "place": "90km ENE of King Salmon, Alaska",
        "time": 1507631764611,
        "updated": 1507632223427,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak17004182",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak17004182.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 129,
        "net": "ak",
        "code": "17004182",
        "ids": ",ak17004182,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.69,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 90km ENE of King Salmon, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-155.1458, 58.8936, 179.2]},
      "id": "ak17004182"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "31km NE of Squaw Valley, California",
        "time": 1507617807660,
        "updated": 1507619433527,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906876",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906876.geojsonp",
        "felt": 2,
        "cdi": 2.7,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 113,
        "net": "nc",
        "code": "72906876",
        "ids": ",nc72906876,",
        "sources": ",nc,",
        "types": ",dyfi,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 6,
        "dmin": 0.5419,
        "rms": 0.3,
        "gap": 228,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.7 - 31km NE of Squaw Valley, California"
      },
      "geometry": {"type": "Point", "coordinates": [-118.9840012, 36.9300003, 2.29]},
      "id": "nc72906876"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 6.3,
        "place": "36km SSW of Putre, Chile",
        "time": 1507617140800,
        "updated": 1507640305590,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b3dm",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b3dm.geojsonp",
        "felt": 85,
        "cdi": 4.8,
        "mmi": 5.05,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 651,
        "net": "us",
        "code": "2000b3dm",
        "ids": ",us2000b3dm,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,losspager,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 0.224,
        "rms": 1.47,
        "gap": 27,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 6.3 - 36km SSW of Putre, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-69.6411, -18.5212, 82.43]},
      "id": "us2000b3dm"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "65km ENE of Manley Hot Springs, Alaska",
        "time": 1507615738567,
        "updated": 1507616637274,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak17003202",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak17003202.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "17003202",
        "ids": ",ak17003202,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.71,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 65km ENE of Manley Hot Springs, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-149.3053, 65.1738, 14.5]},
      "id": "ak17003202"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.49,
        "place": "8km NW of Alberto Oviedo Mota, B.C., MX",
        "time": 1507607134930,
        "updated": 1507607661952,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38022272",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38022272.geojsonp",
        "felt": 1,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 96,
        "net": "ci",
        "code": "38022272",
        "ids": ",ci38022272,",
        "sources": ",ci,",
        "types": ",dyfi,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 17,
        "dmin": 0.1207,
        "rms": 0.27,
        "gap": 217,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 8km NW of Alberto Oviedo Mota, B.C., MX"
      },
      "geometry": {"type": "Point", "coordinates": [-115.2163333, 32.282, 11.16]},
      "id": "ci38022272"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.92,
        "place": "6km W of Kenwood, California",
        "time": 1507605399470,
        "updated": 1507633700312,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906831",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906831.geojsonp",
        "felt": 212,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 203,
        "net": "nc",
        "code": "72906831",
        "ids": ",nc72906831,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 52,
        "dmin": 0.03815,
        "rms": 0.11,
        "gap": 76,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.9 - 6km W of Kenwood, California"
      },
      "geometry": {"type": "Point", "coordinates": [-122.6240005, 38.4119987, 6.46]},
      "id": "nc72906831"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.75,
        "place": "23km E of Mount Hood Village, Oregon",
        "time": 1507603537050,
        "updated": 1507610938095,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/uw61339596",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/uw61339596.geojsonp",
        "felt": 4,
        "cdi": 2.7,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 117,
        "net": "uw",
        "code": "61339596",
        "ids": ",uw61339596,",
        "sources": ",uw,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 25,
        "dmin": 0.02276,
        "rms": 0.16,
        "gap": 45,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.8 - 23km E of Mount Hood Village, Oregon"
      },
      "geometry": {"type": "Point", "coordinates": [-121.6861667, 45.3206667, 6.84]},
      "id": "uw61339596"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.54,
        "place": "24km SSE of Portola, California",
        "time": 1507602756000,
        "updated": 1507606935564,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906801",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906801.geojsonp",
        "felt": 11,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 102,
        "net": "nc",
        "code": "72906801",
        "ids": ",nc72906801,nn00608706,",
        "sources": ",nc,nn,",
        "types": ",dyfi,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 17,
        "dmin": 0.1383,
        "rms": 0.13,
        "gap": 87,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 24km SSE of Portola, California"
      },
      "geometry": {"type": "Point", "coordinates": [-120.3980026, 39.5999985, -1.22]},
      "id": "nc72906801"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.09,
        "place": "14km ESE of Alum Rock, California",
        "time": 1507596798220,
        "updated": 1507640844493,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906781",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906781.geojsonp",
        "felt": 5171,
        "cdi": 4.1,
        "mmi": 3.83,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 1,
        "sig": 667,
        "net": "nc",
        "code": "72906781",
        "ids": ",nc72906781,at00oxl14t,us2000b3ba,",
        "sources": ",nc,at,us,",
        "types": ",dyfi,focal-mechanism,geoserve,impact-link,losspager,moment-tensor,nearby-cities,origin,phase-data,scitech-link,shakemap,",
        "nst": 80,
        "dmin": 0.04293,
        "rms": 0.06,
        "gap": 33,
        "magType": "mw",
        "type": "earthquake",
        "title": "M 4.1 - 14km ESE of Alum Rock, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.6794968, 37.3103333, 7.91]},
      "id": "nc72906781"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "99km W of Onan Ganjang, Indonesia",
        "time": 1507595243360,
        "updated": 1507624208421,
        "tz": 420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b3b2",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b3b2.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b3b2",
        "ids": ",us2000b3b2,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.866,
        "rms": 0.9,
        "gap": 126,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 99km W of Onan Ganjang, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [97.7322, 2.1621, 55.07]},
      "id": "us2000b3b2"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.57,
        "place": "8km NE of Aguanga, CA",
        "time": 1507594485820,
        "updated": 1507615721932,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38022200",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38022200.geojsonp",
        "felt": 4,
        "cdi": 3.1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 103,
        "net": "ci",
        "code": "38022200",
        "ids": ",ci38022200,",
        "sources": ",ci,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 87,
        "dmin": 0.01659,
        "rms": 0.19,
        "gap": 27,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 8km NE of Aguanga, CA"
      },
      "geometry": {"type": "Point", "coordinates": [-116.7978333, 33.491, 3.88]},
      "id": "ci38022200"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "233km NW of Saumlaki, Indonesia",
        "time": 1507593897870,
        "updated": 1507609643040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b3av",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b3av.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "2000b3av",
        "ids": ",us2000b3av,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.111,
        "rms": 0.92,
        "gap": 32,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - 233km NW of Saumlaki, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [129.8246, -6.4493, 155.27]},
      "id": "us2000b3av"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "6km SSW of Coquimbo, Chile",
        "time": 1507589752540,
        "updated": 1507601505404,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b39y",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b39y.geojsonp",
        "felt": 5,
        "cdi": 3.3,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 299,
        "net": "us",
        "code": "2000b39y",
        "ids": ",us2000b39y,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.152,
        "rms": 0.98,
        "gap": 88,
        "magType": "mwr",
        "type": "earthquake",
        "title": "M 4.4 - 6km SSW of Coquimbo, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-71.3827, -30.0051, 50.54]},
      "id": "us2000b39y"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4,
        "place": "84km SSW of Unalaska, Alaska",
        "time": 1507589526450,
        "updated": 1507598250040,
        "tz": -660,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b39z",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b39z.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 246,
        "net": "us",
        "code": "2000b39z",
        "ids": ",ak17001047,us2000b39z,",
        "sources": ",ak,us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.87,
        "gap": null,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.0 - 84km SSW of Unalaska, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-166.8557, 53.1363, 67.9]},
      "id": "us2000b39z"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "77km ENE of Duang, Indonesia",
        "time": 1507587827700,
        "updated": 1507588797040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b39g",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b39g.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 1,
        "sig": 385,
        "net": "us",
        "code": "2000b39g",
        "ids": ",us2000b39g,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.185,
        "rms": 1.09,
        "gap": 57,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - 77km ENE of Duang, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [123.3963, -8.3295, 10]},
      "id": "us2000b39g"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "16km SSE of Ridgemark, California",
        "time": 1507562587880,
        "updated": 1507599545100,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906621",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906621.geojsonp",
        "felt": 4,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 113,
        "net": "nc",
        "code": "72906621",
        "ids": ",nc72906621,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 41,
        "dmin": 0.05937,
        "rms": 0.05,
        "gap": 70,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.7 - 16km SSE of Ridgemark, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.3001633, 36.6744995, 3.28]},
      "id": "nc72906621"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.12,
        "place": "13km SE of Lincoln, Montana",
        "time": 1507561110180,
        "updated": 1507563780923,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/mb80260334",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/mb80260334.geojsonp",
        "felt": 3,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 151,
        "net": "mb",
        "code": "80260334",
        "ids": ",mb80260334,",
        "sources": ",mb,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 28,
        "dmin": 0.049,
        "rms": 0.19,
        "gap": 90,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.1 - 13km SE of Lincoln, Montana"
      },
      "geometry": {"type": "Point", "coordinates": [-112.5486667, 46.8793333, 11.97]},
      "id": "mb80260334"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.9,
        "place": "31km SSW of Hawthorne, Nevada",
        "time": 1507559984731,
        "updated": 1507603097667,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nn00608570",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nn00608570.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 129,
        "net": "nn",
        "code": "00608570",
        "ids": ",nc72906601,nn00608570,",
        "sources": ",nc,nn,",
        "types": ",focal-mechanism,geoserve,origin,phase-data,scitech-link,",
        "nst": 40,
        "dmin": 0.162,
        "rms": 0.2261,
        "gap": 34.81,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 31km SSW of Hawthorne, Nevada"
      },
      "geometry": {"type": "Point", "coordinates": [-118.7109, 38.247, 6.9]},
      "id": "nn00608570"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.47,
        "place": "19km SE of Mammoth Lakes, California",
        "time": 1507558195410,
        "updated": 1507565883938,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906581",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906581.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 94,
        "net": "nc",
        "code": "72906581",
        "ids": ",nc72906581,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 31,
        "dmin": 0.07529,
        "rms": 0.04,
        "gap": 103,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 19km SE of Mammoth Lakes, California"
      },
      "geometry": {"type": "Point", "coordinates": [-118.8328323, 37.5146675, 1.63]},
      "id": "nc72906581"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.52,
        "place": "5km S of Lilbourn, Missouri",
        "time": 1507557288160,
        "updated": 1507604366300,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nm60208301",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nm60208301.geojsonp",
        "felt": 9,
        "cdi": 3.1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 100,
        "net": "nm",
        "code": "60208301",
        "ids": ",nm60208301,",
        "sources": ",nm,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 49,
        "dmin": 0.03971,
        "rms": 0.12,
        "gap": 36,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 5km S of Lilbourn, Missouri"
      },
      "geometry": {"type": "Point", "coordinates": [-89.6161667, 36.5431667, 8.72]},
      "id": "nm60208301"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.86,
        "place": "6km SW of Santa Barbara Is., CA",
        "time": 1507545626850,
        "updated": 1507618606961,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38021952",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38021952.geojsonp",
        "felt": 11,
        "cdi": 2.5,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 129,
        "net": "ci",
        "code": "38021952",
        "ids": ",ci38021952,",
        "sources": ",ci,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 30,
        "dmin": 0.07497,
        "rms": 0.27,
        "gap": 109,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 6km SW of Santa Barbara Is., CA"
      },
      "geometry": {"type": "Point", "coordinates": [-119.1006667, 33.4343333, 10.94]},
      "id": "ci38021952"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "100km SSE of King Salmon, Alaska",
        "time": 1507544851023,
        "updated": 1507545222201,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16999786",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16999786.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16999786",
        "ids": ",ak16999786,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.29,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 100km SSE of King Salmon, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-156.2357, 57.8141, 123.1]},
      "id": "ak16999786"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.48,
        "place": "20km S of Bodfish, CA",
        "time": 1507540529080,
        "updated": 1507578195150,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38021936",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38021936.geojsonp",
        "felt": 4,
        "cdi": 3.1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 96,
        "net": "ci",
        "code": "38021936",
        "ids": ",ci38021936,",
        "sources": ",ci,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 41,
        "dmin": 0.1191,
        "rms": 0.16,
        "gap": 46,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 20km S of Bodfish, CA"
      },
      "geometry": {"type": "Point", "coordinates": [-118.4491667, 35.4083333, 1.3]},
      "id": "ci38021936"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.17,
        "place": "26km SW of Rio Dell, California",
        "time": 1507540259310,
        "updated": 1507598598013,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906461",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906461.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 155,
        "net": "nc",
        "code": "72906461",
        "ids": ",nc72906461,",
        "sources": ",nc,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 8,
        "dmin": 0.1396,
        "rms": 0.09,
        "gap": 220,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.2 - 26km SW of Rio Dell, California"
      },
      "geometry": {"type": "Point", "coordinates": [-124.3375015, 40.3358345, 17.31]},
      "id": "nc72906461"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.1,
        "place": "South Indian Ocean",
        "time": 1507539908670,
        "updated": 1507540872040,
        "tz": 360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2z1",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2z1.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 400,
        "net": "us",
        "code": "2000b2z1",
        "ids": ",us2000b2z1,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.914,
        "rms": 1.14,
        "gap": 113,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.1 - South Indian Ocean"
      },
      "geometry": {"type": "Point", "coordinates": [95.7764, -7.3574, 10]},
      "id": "us2000b2z1"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "100km SW of Lata, Solomon Islands",
        "time": 1507536304190,
        "updated": 1507538075040,
        "tz": 660,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2yw",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2yw.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "2000b2yw",
        "ids": ",us2000b2yw,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.371,
        "rms": 0.58,
        "gap": 57,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - 100km SW of Lata, Solomon Islands"
      },
      "geometry": {"type": "Point", "coordinates": [165.0914, -11.2487, 20.26]},
      "id": "us2000b2yw"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.78,
        "place": "24km ENE of Soledad, California",
        "time": 1507531566100,
        "updated": 1507560538009,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906446",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906446.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 119,
        "net": "nc",
        "code": "72906446",
        "ids": ",nc72906446,",
        "sources": ",nc,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 14,
        "dmin": 0.08028,
        "rms": 0.04,
        "gap": 133,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.8 - 24km ENE of Soledad, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.0701675, 36.4953346, 3.88]},
      "id": "nc72906446"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.94,
        "place": "23km ENE of Soledad, California",
        "time": 1507531546870,
        "updated": 1507601328829,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906441",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906441.geojsonp",
        "felt": 2,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 133,
        "net": "nc",
        "code": "72906441",
        "ids": ",nc72906441,",
        "sources": ",nc,",
        "types": ",dyfi,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 22,
        "dmin": 0.08444,
        "rms": 0.07,
        "gap": 130,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.9 - 23km ENE of Soledad, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.074501, 36.4964981, 3.74]},
      "id": "nc72906441"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.95,
        "place": "2km ESE of Loma Linda, CA",
        "time": 1507531188230,
        "updated": 1507619409732,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38021888",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38021888.geojsonp",
        "felt": 330,
        "cdi": 4.1,
        "mmi": 3.33,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 269,
        "net": "ci",
        "code": "38021888",
        "ids": ",ci38021888,",
        "sources": ",ci,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,shakemap,",
        "nst": 176,
        "dmin": 0.01306,
        "rms": 0.19,
        "gap": 15,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.0 - 2km ESE of Loma Linda, CA"
      },
      "geometry": {"type": "Point", "coordinates": [-117.2388333, 34.0406667, 18.05]},
      "id": "ci38021888"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "53km SSE of Copiapo, Chile",
        "time": 1507529611580,
        "updated": 1507534379648,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2yg",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2yg.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 272,
        "net": "us",
        "code": "2000b2yg",
        "ids": ",us2000b2yg,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.239,
        "rms": 1.44,
        "gap": 98,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 53km SSE of Copiapo, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-70.1866, -27.8305, 98.15]},
      "id": "us2000b2yg"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "75km E of Cape Yakataga, Alaska",
        "time": 1507528688366,
        "updated": 1507569050313,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16998967",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16998967.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16998967",
        "ids": ",ak16998967,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.48,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 75km E of Cape Yakataga, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-141.085, 60.0022, 6.4]},
      "id": "ak16998967"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "42km SE of Kupang, Indonesia",
        "time": 1507525782610,
        "updated": 1507529976040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2y8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2y8.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2y8",
        "ids": ",us2000b2y8,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.82,
        "rms": 1.07,
        "gap": 64,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 42km SE of Kupang, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [123.837, -10.4622, 35]},
      "id": "us2000b2y8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.45,
        "place": "14km SE of Lincoln, Montana",
        "time": 1507525702460,
        "updated": 1507558702320,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/mb80260269",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/mb80260269.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 92,
        "net": "mb",
        "code": "80260269",
        "ids": ",mb80260269,",
        "sources": ",mb,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 23,
        "dmin": 0.046,
        "rms": 0.16,
        "gap": 72,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 14km SE of Lincoln, Montana"
      },
      "geometry": {"type": "Point", "coordinates": [-112.529, 46.8725, 11.69]},
      "id": "mb80260269"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "40km E of Palora, Ecuador",
        "time": 1507522521700,
        "updated": 1507525791173,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2xw",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2xw.geojsonp",
        "felt": 3,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 370,
        "net": "us",
        "code": "2000b2xw",
        "ids": ",us2000b2xw,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.314,
        "rms": 1.09,
        "gap": 35,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - 40km E of Palora, Ecuador"
      },
      "geometry": {"type": "Point", "coordinates": [-77.5661, -1.6737, 173.38]},
      "id": "us2000b2xw"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.4,
        "place": "Mid-Indian Ridge",
        "time": 1507520804050,
        "updated": 1507521891040,
        "tz": 240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2xs",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2xs.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 449,
        "net": "us",
        "code": "2000b2xs",
        "ids": ",us2000b2xs,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 13.102,
        "rms": 0.78,
        "gap": 36,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.4 - Mid-Indian Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [66.3211, -12.7951, 10]},
      "id": "us2000b2xs"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "140km N of Calama, Chile",
        "time": 1507513314310,
        "updated": 1507516312040,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2xf",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2xf.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b2xf",
        "ids": ",us2000b2xf,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.708,
        "rms": 0.69,
        "gap": 83,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 140km N of Calama, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-68.7497, -21.2087, 123.26]},
      "id": "us2000b2xf"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "121km SSW of Kulumadau, Papua New Guinea",
        "time": 1507513162800,
        "updated": 1507514406040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2xh",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2xh.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b2xh",
        "ids": ",us2000b2xh,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.11,
        "rms": 0.89,
        "gap": 87,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 121km SSW of Kulumadau, Papua New Guinea"
      },
      "geometry": {"type": "Point", "coordinates": [152.3009, -10.0686, 10]},
      "id": "us2000b2xh"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.1,
        "place": "3km NNE of Arkhaia Korinthos, Greece",
        "time": 1507511969540,
        "updated": 1507526826850,
        "tz": 120,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2x9",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2x9.geojsonp",
        "felt": 2,
        "cdi": 3.1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 259,
        "net": "us",
        "code": "2000b2x9",
        "ids": ",us2000b2x9,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.579,
        "rms": 0.99,
        "gap": 96,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.1 - 3km NNE of Arkhaia Korinthos, Greece"
      },
      "geometry": {"type": "Point", "coordinates": [22.9007, 37.9467, 10]},
      "id": "us2000b2x9"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "70km N of Yakutat, Alaska",
        "time": 1507510577640,
        "updated": 1507560713631,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2x8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2x8.geojsonp",
        "felt": 1,
        "cdi": 1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 112,
        "net": "us",
        "code": "2000b2x8",
        "ids": ",us2000b2x8,ak16998142,",
        "sources": ",us,ak,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.55,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 70km N of Yakutat, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-139.5376, 60.1751, 0]},
      "id": "us2000b2x8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "Mid-Indian Ridge",
        "time": 1507508904520,
        "updated": 1507610199040,
        "tz": 240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2x2",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2x2.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2x2",
        "ids": ",us2000b2x2,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 7.45,
        "rms": 0.9,
        "gap": 27,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - Mid-Indian Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [66.3323, -12.8297, 10]},
      "id": "us2000b2x2"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "65km SW of Puerto Madero, Mexico",
        "time": 1507507675790,
        "updated": 1507610310529,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2wu",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2wu.geojsonp",
        "felt": 1,
        "cdi": 2.7,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 285,
        "net": "us",
        "code": "2000b2wu",
        "ids": ",us2000b2wu,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.131,
        "rms": 0.86,
        "gap": 181,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 65km SW of Puerto Madero, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-92.8363, 14.2837, 45.08]},
      "id": "us2000b2wu"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "45km SE of Taitung City, Taiwan",
        "time": 1507505392950,
        "updated": 1507610727040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2wh",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2wh.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b2wh",
        "ids": ",us2000b2wh,",
        "sources": ",us,",
        "types": ",geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.497,
        "rms": 0.88,
        "gap": 68,
        "magType": "mwr",
        "type": "earthquake",
        "title": "M 4.6 - 45km SE of Taitung City, Taiwan"
      },
      "geometry": {"type": "Point", "coordinates": [121.4456, 22.4515, 21.09]},
      "id": "us2000b2wh"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "30km NW of Santa Cruz, Chile",
        "time": 1507504219860,
        "updated": 1507610985751,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2w8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2w8.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 285,
        "net": "us",
        "code": "2000b2w8",
        "ids": ",us2000b2w8,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.418,
        "rms": 0.72,
        "gap": 64,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 30km NW of Santa Cruz, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-71.5891, -34.4239, 48.09]},
      "id": "us2000b2w8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.91,
        "place": "16km ESE of Mammoth Lakes, California",
        "time": 1507502735440,
        "updated": 1507528713267,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906231",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906231.geojsonp",
        "felt": 2,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 131,
        "net": "nc",
        "code": "72906231",
        "ids": ",nc72906231,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 38,
        "dmin": 0.01733,
        "rms": 0.05,
        "gap": 118,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.9 - 16km ESE of Mammoth Lakes, California"
      },
      "geometry": {"type": "Point", "coordinates": [-118.8085022, 37.5843315, 10.1]},
      "id": "nc72906231"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.9,
        "place": "108km NW of Talkeetna, Alaska",
        "time": 1507502089984,
        "updated": 1507502505830,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16997549",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16997549.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 129,
        "net": "ak",
        "code": "16997549",
        "ids": ",ak16997549,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.96,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 108km NW of Talkeetna, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-151.4395, 63.0828, 0]},
      "id": "ak16997549"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 6.6,
        "place": "60km E of Buldir Island, Alaska",
        "time": 1507502073960,
        "updated": 1507578239703,
        "tz": 720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2vq",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2vq.geojsonp",
        "felt": 2,
        "cdi": 3.3,
        "mmi": 4.77,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 1,
        "sig": 671,
        "net": "us",
        "code": "2000b2vq",
        "ids": ",us2000b2vq,at00oxj01l,pt17281002,ak16997547,",
        "sources": ",us,at,pt,ak,",
        "types": ",associate,dyfi,geoserve,impact-link,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 1.673,
        "rms": 0.79,
        "gap": 72,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 6.6 - 60km E of Buldir Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [176.8078, 52.4496, 111.84]},
      "id": "us2000b2vq"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 6.3,
        "place": "Balleny Islands region",
        "time": 1507495738720,
        "updated": 1507506047040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2v1",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2v1.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": 0,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 611,
        "net": "us",
        "code": "2000b2v1",
        "ids": ",us2000b2v1,",
        "sources": ",us,",
        "types": ",geoserve,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 7.628,
        "rms": 1,
        "gap": 101,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 6.3 - Balleny Islands region"
      },
      "geometry": {"type": "Point", "coordinates": [154.5526, -61.7431, 10]},
      "id": "us2000b2v1"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "4km E of Harper, Kansas",
        "time": 1507494018030,
        "updated": 1507572244717,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2uw",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2uw.geojsonp",
        "felt": 6,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 105,
        "net": "us",
        "code": "2000b2uw",
        "ids": ",us2000b2uw,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.022,
        "rms": 0.23,
        "gap": 117,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 2.6 - 4km E of Harper, Kansas"
      },
      "geometry": {"type": "Point", "coordinates": [-97.9736, 37.2855, 5.36]},
      "id": "us2000b2uw"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "19km W of Perry, Oklahoma",
        "time": 1507491463720,
        "updated": 1507541080340,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2ue",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2ue.geojsonp",
        "felt": 2,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 113,
        "net": "us",
        "code": "2000b2ue",
        "ids": ",us2000b2ue,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.21,
        "rms": 0.12,
        "gap": 31,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 2.7 - 19km W of Perry, Oklahoma"
      },
      "geometry": {"type": "Point", "coordinates": [-97.5059, 36.2764, 4.85]},
      "id": "us2000b2ue"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3,
        "place": "38km E of Old Iliamna, Alaska",
        "time": 1507491239341,
        "updated": 1507491591316,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16996825",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16996825.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 138,
        "net": "ak",
        "code": "16996825",
        "ids": ",ak16996825,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.55,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.0 - 38km E of Old Iliamna, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-154.2317, 59.7203, 185.2]},
      "id": "ak16996825"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "224km N of Chichi-shima, Japan",
        "time": 1507490382110,
        "updated": 1507491985040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2u8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2u8.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2u8",
        "ids": ",us2000b2u8,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.006,
        "rms": 0.92,
        "gap": 192,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 224km N of Chichi-shima, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [142.3426, 29.1048, 20.24]},
      "id": "us2000b2u8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.49,
        "place": "15km ESE of Soda Springs, Idaho",
        "time": 1507488057150,
        "updated": 1507568234520,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/uu60251757",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/uu60251757.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 95,
        "net": "uu",
        "code": "60251757",
        "ids": ",uu60251757,",
        "sources": ",uu,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 28,
        "dmin": 0.01226,
        "rms": 0.26,
        "gap": 47,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 15km ESE of Soda Springs, Idaho"
      },
      "geometry": {"type": "Point", "coordinates": [-111.4403333, 42.5941667, 3.5]},
      "id": "uu60251757"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.11,
        "place": "15km ESE of Soda Springs, Idaho",
        "time": 1507475359790,
        "updated": 1507620697329,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/uu60251727",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/uu60251727.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 149,
        "net": "uu",
        "code": "60251727",
        "ids": ",uu60251727,",
        "sources": ",uu,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 33,
        "dmin": 0.007446,
        "rms": 0.22,
        "gap": 45,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.1 - 15km ESE of Soda Springs, Idaho"
      },
      "geometry": {"type": "Point", "coordinates": [-111.4421667, 42.5875, 3.5]},
      "id": "uu60251727"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.25,
        "place": "15km ESE of Soda Springs, Idaho",
        "time": 1507475168200,
        "updated": 1507620417738,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/uu60251722",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/uu60251722.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 163,
        "net": "uu",
        "code": "60251722",
        "ids": ",uu60251722,",
        "sources": ",uu,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 31,
        "dmin": 0.003793,
        "rms": 0.23,
        "gap": 45,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.3 - 15km ESE of Soda Springs, Idaho"
      },
      "geometry": {"type": "Point", "coordinates": [-111.4466667, 42.5851667, 3.5]},
      "id": "uu60251722"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "Northern Mid-Atlantic Ridge",
        "time": 1507472054190,
        "updated": 1507473457040,
        "tz": -180,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2t0",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2t0.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 385,
        "net": "us",
        "code": "2000b2t0",
        "ids": ",us2000b2t0,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 19.814,
        "rms": 1.13,
        "gap": 87,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - Northern Mid-Atlantic Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [-41.2812, 10.5846, 10]},
      "id": "us2000b2t0"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 6.1,
        "place": "153km NW of Pangai, Tonga",
        "time": 1507471478540,
        "updated": 1507527978040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2sv",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2sv.geojsonp",
        "felt": 1,
        "cdi": 1,
        "mmi": 3.83,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 573,
        "net": "us",
        "code": "2000b2sv",
        "ids": ",us2000b2sv,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 5.324,
        "rms": 1.73,
        "gap": 81,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 6.1 - 153km NW of Pangai, Tonga"
      },
      "geometry": {"type": "Point", "coordinates": [-175.5559, -19.0132, 10]},
      "id": "us2000b2sv"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "4km WSW of Tapas, Philippines",
        "time": 1507466557930,
        "updated": 1507501487491,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2vf",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2vf.geojsonp",
        "felt": 4,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 313,
        "net": "us",
        "code": "2000b2vf",
        "ids": ",us2000b2vf,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 7.213,
        "rms": 0.72,
        "gap": 152,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 4km WSW of Tapas, Philippines"
      },
      "geometry": {"type": "Point", "coordinates": [122.5021, 11.2453, 29.36]},
      "id": "us2000b2vf"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "125km NE of Namatanai, Papua New Guinea",
        "time": 1507465491460,
        "updated": 1507466505040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2sq",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2sq.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 1,
        "sig": 385,
        "net": "us",
        "code": "2000b2sq",
        "ids": ",us2000b2sq,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.68,
        "rms": 0.54,
        "gap": 81,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - 125km NE of Namatanai, Papua New Guinea"
      },
      "geometry": {"type": "Point", "coordinates": [153.3053, -2.9471, 32.6]},
      "id": "us2000b2sq"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.46,
        "place": "29km ENE of Soledad, California",
        "time": 1507457481340,
        "updated": 1507476379299,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72906046",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72906046.geojsonp",
        "felt": 5,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 94,
        "net": "nc",
        "code": "72906046",
        "ids": ",nc72906046,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 30,
        "dmin": 0.03906,
        "rms": 0.07,
        "gap": 108,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 29km ENE of Soledad, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.0353317, 36.5395012, 5.99]},
      "id": "nc72906046"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "278km WSW of Tomatlan, Mexico",
        "time": 1507453920040,
        "updated": 1507454871040,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2rr",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2rr.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2rr",
        "ids": ",us2000b2rr,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.282,
        "rms": 0.99,
        "gap": 179,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - 278km WSW of Tomatlan, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-107.6352, 18.8379, 10]},
      "id": "us2000b2rr"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3,
        "place": "47km WNW of Haines Junction, Canada",
        "time": 1507442418372,
        "updated": 1507442956173,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16995404",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16995404.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 138,
        "net": "ak",
        "code": "16995404",
        "ids": ",ak16995404,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.62,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.0 - 47km WNW of Haines Junction, Canada"
      },
      "geometry": {"type": "Point", "coordinates": [-138.359, 60.8489, 0]},
      "id": "ak16995404"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.1,
        "place": "44km SSW of Nueva Concepcion, Guatemala",
        "time": 1507438840200,
        "updated": 1507468875314,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2qv",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2qv.geojsonp",
        "felt": 1,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 259,
        "net": "us",
        "code": "2000b2qv",
        "ids": ",us2000b2qv,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.692,
        "rms": 0.77,
        "gap": 157,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.1 - 44km SSW of Nueva Concepcion, Guatemala"
      },
      "geometry": {"type": "Point", "coordinates": [-91.5042, 13.8539, 21.12]},
      "id": "us2000b2qv"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "55km E of Lakatoro, Vanuatu",
        "time": 1507438306020,
        "updated": 1507440350040,
        "tz": 660,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2qy",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2qy.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b2qy",
        "ids": ",us2000b2qy,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.694,
        "rms": 0.87,
        "gap": 215,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 55km E of Lakatoro, Vanuatu"
      },
      "geometry": {"type": "Point", "coordinates": [167.9388, -16.1049, 155.76]},
      "id": "us2000b2qy"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "91km SW of Corinto, Nicaragua",
        "time": 1507437286600,
        "updated": 1507446897567,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2qn",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2qn.geojsonp",
        "felt": 2,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 272,
        "net": "us",
        "code": "2000b2qn",
        "ids": ",us2000b2qn,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.053,
        "rms": 1.31,
        "gap": 193,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 91km SW of Corinto, Nicaragua"
      },
      "geometry": {"type": "Point", "coordinates": [-87.8324, 11.9675, 46.28]},
      "id": "us2000b2qn"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "91km SW of Corinto, Nicaragua",
        "time": 1507436879480,
        "updated": 1507438626040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2qg",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2qg.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2qg",
        "ids": ",us2000b2qg,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.053,
        "rms": 0.84,
        "gap": 151,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 91km SW of Corinto, Nicaragua"
      },
      "geometry": {"type": "Point", "coordinates": [-87.8364, 11.9716, 43.85]},
      "id": "us2000b2qg"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.54,
        "place": "28km S of Rio Dell, California",
        "time": 1507436780870,
        "updated": 1507437904095,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72905946",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72905946.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 99,
        "net": "nc",
        "code": "72905946",
        "ids": ",nc72905946,",
        "sources": ",nc,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 10,
        "dmin": 0.006807,
        "rms": 0.13,
        "gap": 117,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 28km S of Rio Dell, California"
      },
      "geometry": {"type": "Point", "coordinates": [-124.1624985, 40.2496681, 9.21]},
      "id": "nc72905946"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "95km SW of Corinto, Nicaragua",
        "time": 1507436002670,
        "updated": 1507437281040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2qc",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2qc.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2qc",
        "ids": ",us2000b2qc,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.09,
        "rms": 0.72,
        "gap": 151,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 95km SW of Corinto, Nicaragua"
      },
      "geometry": {"type": "Point", "coordinates": [-87.8214, 11.9031, 42.42]},
      "id": "us2000b2qc"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "86km SW of Corinto, Nicaragua",
        "time": 1507433926730,
        "updated": 1507435138040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2q3",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2q3.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2q3",
        "ids": ",us2000b2q3,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.005,
        "rms": 1.03,
        "gap": 155,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - 86km SW of Corinto, Nicaragua"
      },
      "geometry": {"type": "Point", "coordinates": [-87.7978, 12.0018, 37.19]},
      "id": "us2000b2q3"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.86,
        "place": "3km W of San Juan Bautista, California",
        "time": 1507426815710,
        "updated": 1507610852583,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72905891",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72905891.geojsonp",
        "felt": 20,
        "cdi": 2.8,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 131,
        "net": "nc",
        "code": "72905891",
        "ids": ",nc72905891,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 53,
        "dmin": 0.02024,
        "rms": 0.12,
        "gap": 41,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.9 - 3km W of San Juan Bautista, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.5768356, 36.8470001, 5.61]},
      "id": "nc72905891"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "26km ESE of Muroran, Japan",
        "time": 1507426697730,
        "updated": 1507428726040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2p9",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2p9.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2p9",
        "ids": ",us2000b2p9,",
        "sources": ",us,",
        "types": ",geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 1.4,
        "rms": 0.81,
        "gap": 45,
        "magType": "mwr",
        "type": "earthquake",
        "title": "M 4.5 - 26km ESE of Muroran, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [141.3056, 42.2678, 118.72]},
      "id": "us2000b2p9"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "1km NW of Santiago Suchilquitongo, Mexico",
        "time": 1507425671830,
        "updated": 1507483556280,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2p1",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2p1.geojsonp",
        "felt": 10,
        "cdi": 4.5,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 344,
        "net": "us",
        "code": "2000b2p1",
        "ids": ",us2000b2p1,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.621,
        "rms": 0.81,
        "gap": 128,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 1km NW of Santiago Suchilquitongo, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-96.8983, 17.2598, 58.89]},
      "id": "us2000b2p1"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.5,
        "place": "65km ESE of Lakeview, Oregon",
        "time": 1507425045592,
        "updated": 1507516598081,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nn00608431",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nn00608431.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": 3.15,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 188,
        "net": "nn",
        "code": "00608431",
        "ids": ",nn00608431,",
        "sources": ",nn,",
        "types": ",geoserve,origin,phase-data,shakemap,",
        "nst": 14,
        "dmin": 0.12,
        "rms": 0.2293,
        "gap": 77.48,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.5 - 65km ESE of Lakeview, Oregon"
      },
      "geometry": {"type": "Point", "coordinates": [-119.6568, 41.8912, 13.8]},
      "id": "nn00608431"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "72km SW of Corinto, Nicaragua",
        "time": 1507422626990,
        "updated": 1507424640040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2nn",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2nn.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 271,
        "net": "us",
        "code": "2000b2nn",
        "ids": ",us2000b2nn,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.887,
        "rms": 0.69,
        "gap": 185,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 72km SW of Corinto, Nicaragua"
      },
      "geometry": {"type": "Point", "coordinates": [-87.6901, 12.0623, 46.41]},
      "id": "us2000b2nn"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "47km NNE of Ndoi Island, Fiji",
        "time": 1507420784440,
        "updated": 1507421803040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2nb",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2nb.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b2nb",
        "ids": ",us2000b2nb,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.158,
        "rms": 0.81,
        "gap": 89,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 47km NNE of Ndoi Island, Fiji"
      },
      "geometry": {"type": "Point", "coordinates": [-178.4576, -20.2873, 614.26]},
      "id": "us2000b2nb"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.1,
        "place": "49km SSE of Iztapa, Guatemala",
        "time": 1507411448780,
        "updated": 1507412934040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2ly",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2ly.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 259,
        "net": "us",
        "code": "2000b2ly",
        "ids": ",us2000b2ly,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.288,
        "rms": 1.13,
        "gap": 184,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.1 - 49km SSE of Iztapa, Guatemala"
      },
      "geometry": {"type": "Point", "coordinates": [-90.5445, 13.5146, 54.36]},
      "id": "us2000b2ly"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.55,
        "place": "15km S of Fern Acres, Hawaii",
        "time": 1507406278360,
        "updated": 1507406629410,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61936851",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61936851.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 100,
        "net": "hv",
        "code": "61936851",
        "ids": ",hv61936851,",
        "sources": ",hv,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 48,
        "dmin": 0.02376,
        "rms": 0.25,
        "gap": 148,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 15km S of Fern Acres, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.0786591, 19.3741665, 2.15]},
      "id": "hv61936851"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "171km WNW of Pangai, Tonga",
        "time": 1507398878370,
        "updated": 1507558273040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2jk",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2jk.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b2jk",
        "ids": ",us2000b2jk,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.502,
        "rms": 0.85,
        "gap": 80,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 171km WNW of Pangai, Tonga"
      },
      "geometry": {"type": "Point", "coordinates": [-175.7429, -18.9839, 194.67]},
      "id": "us2000b2jk"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.64,
        "place": "24km NE of Soledad, California",
        "time": 1507397278960,
        "updated": 1507427629001,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72905766",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72905766.geojsonp",
        "felt": 4,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 108,
        "net": "nc",
        "code": "72905766",
        "ids": ",nc72905766,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 40,
        "dmin": 0.04262,
        "rms": 0.09,
        "gap": 77,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.6 - 24km NE of Soledad, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.1374969, 36.579834, 7.72]},
      "id": "nc72905766"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "27km N of Union Hidalgo, Mexico",
        "time": 1507395765310,
        "updated": 1507556184040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2ii",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2ii.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b2ii",
        "ids": ",us2000b2ii,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.491,
        "rms": 0.57,
        "gap": 181,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 27km N of Union Hidalgo, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.8319, 16.7195, 58.84]},
      "id": "us2000b2ii"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.5,
        "place": "22km WNW of Nikiski, Alaska",
        "time": 1507394741482,
        "updated": 1507395101690,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16993720",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16993720.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 96,
        "net": "ak",
        "code": "16993720",
        "ids": ",ak16993720,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.57,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 22km WNW of Nikiski, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-151.6683, 60.7696, 67.1]},
      "id": "ak16993720"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "113km NW of Talkeetna, Alaska",
        "time": 1507392435159,
        "updated": 1507439523877,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16993486",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16993486.geojsonp",
        "felt": 3,
        "cdi": 3.4,
        "mmi": 4.34,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 272,
        "net": "ak",
        "code": "16993486",
        "ids": ",ak16993486,us2000b2hy,",
        "sources": ",ak,us,",
        "types": ",dyfi,geoserve,losspager,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": null,
        "rms": 0.71,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 4.2 - 113km NW of Talkeetna, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-151.458, 63.1276, 14.9]},
      "id": "ak16993486"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "14km ENE of San Jeronimo Ixtepec, Mexico",
        "time": 1507392287310,
        "updated": 1507404047040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2hz",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2hz.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b2hz",
        "ids": ",us2000b2hz,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.572,
        "rms": 1.21,
        "gap": 203,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 14km ENE of San Jeronimo Ixtepec, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.9686, 16.6087, 69.65]},
      "id": "us2000b2hz"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "140km SSE of Raoul Island, New Zealand",
        "time": 1507385606770,
        "updated": 1507394724040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2hc",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2hc.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2hc",
        "ids": ",us2000b2hc,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.295,
        "rms": 0.96,
        "gap": 129,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - 140km SSE of Raoul Island, New Zealand"
      },
      "geometry": {"type": "Point", "coordinates": [-177.3179, -30.4302, 10]},
      "id": "us2000b2hc"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.05,
        "place": "30km NNW of Enoch, Utah",
        "time": 1507383200950,
        "updated": 1507565085482,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/uu60251607",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/uu60251607.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": 3.82,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 143,
        "net": "uu",
        "code": "60251607",
        "ids": ",uu60251607,us2000b2gw,",
        "sources": ",uu,us,",
        "types": ",geoserve,origin,phase-data,shakemap,",
        "nst": 28,
        "dmin": 0.1311,
        "rms": 0.2,
        "gap": 46,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.1 - 30km NNW of Enoch, Utah"
      },
      "geometry": {"type": "Point", "coordinates": [-113.1378333, 38.035, 8.12]},
      "id": "uu60251607"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.66,
        "place": "13km SW of Volcano, Hawaii",
        "time": 1507377140600,
        "updated": 1507377484920,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61936531",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61936531.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 109,
        "net": "hv",
        "code": "61936531",
        "ids": ",hv61936531,",
        "sources": ",hv,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 58,
        "dmin": 0.01824,
        "rms": 0.23,
        "gap": 52,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 13km SW of Volcano, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.3201599, 19.3386669, 4.3]},
      "id": "hv61936531"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.1,
        "place": "51km W of La Ligua, Chile",
        "time": 1507372645200,
        "updated": 1507378783416,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2fz",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2fz.geojsonp",
        "felt": 103,
        "cdi": 4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 300,
        "net": "us",
        "code": "2000b2fz",
        "ids": ",us2000b2fz,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.537,
        "rms": 0.7,
        "gap": 181,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.1 - 51km W of La Ligua, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-71.7814, -32.4981, 23.29]},
      "id": "us2000b2fz"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.1,
        "place": "6km NW of Palora, Ecuador",
        "time": 1507368374110,
        "updated": 1507441595936,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2fc",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2fc.geojsonp",
        "felt": 14,
        "cdi": 4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 406,
        "net": "us",
        "code": "2000b2fc",
        "ids": ",us2000b2fc,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.907,
        "rms": 1,
        "gap": 30,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.1 - 6km NW of Palora, Ecuador"
      },
      "geometry": {"type": "Point", "coordinates": [-77.9778, -1.6647, 147.34]},
      "id": "us2000b2fc"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "205km SSE of L'Esperance Rock, New Zealand",
        "time": 1507365487800,
        "updated": 1507366586040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2et",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2et.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2et",
        "ids": ",us2000b2et,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.755,
        "rms": 1.07,
        "gap": 160,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - 205km SSE of L'Esperance Rock, New Zealand"
      },
      "geometry": {"type": "Point", "coordinates": [-177.7469, -33.0092, 10]},
      "id": "us2000b2et"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "219km NW of Saumlaki, Indonesia",
        "time": 1507357181260,
        "updated": 1507358162040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2dx",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2dx.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b2dx",
        "ids": ",us2000b2dx,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.984,
        "rms": 0.65,
        "gap": 69,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 219km NW of Saumlaki, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [130.1291, -6.3628, 156.49]},
      "id": "us2000b2dx"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "55km WSW of Desaguadero, Peru",
        "time": 1507347862040,
        "updated": 1507633200420,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2d1",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2d1.geojsonp",
        "felt": 2,
        "cdi": 2.7,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b2d1",
        "ids": ",us2000b2d1,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.789,
        "rms": 1.1,
        "gap": 96,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 55km WSW of Desaguadero, Peru"
      },
      "geometry": {"type": "Point", "coordinates": [-69.504, -16.7961, 178.13]},
      "id": "us2000b2d1"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.9,
        "place": "Mid-Indian Ridge",
        "time": 1507343887900,
        "updated": 1507346872040,
        "tz": 300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2cx",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2cx.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 369,
        "net": "us",
        "code": "2000b2cx",
        "ids": ",us2000b2cx,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 6.69,
        "rms": 1.25,
        "gap": 55,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.9 - Mid-Indian Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [69.1471, -23.7671, 10]},
      "id": "us2000b2cx"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "269km NW of Manokwari, Indonesia",
        "time": 1507340745260,
        "updated": 1507341898040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2cc",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2cc.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 1,
        "sig": 385,
        "net": "us",
        "code": "2000b2cc",
        "ids": ",us2000b2cc,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.029,
        "rms": 0.83,
        "gap": 98,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - 269km NW of Manokwari, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [132.668, 1.1151, 7.01]},
      "id": "us2000b2cc"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.3,
        "place": "185km SSE of L'Esperance Rock, New Zealand",
        "time": 1507335391250,
        "updated": 1507337118040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2c0",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2c0.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 432,
        "net": "us",
        "code": "2000b2c0",
        "ids": ",us2000b2c0,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.787,
        "rms": 0.98,
        "gap": 70,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.3 - 185km SSE of L'Esperance Rock, New Zealand"
      },
      "geometry": {"type": "Point", "coordinates": [-178.3171, -33.0297, 10]},
      "id": "us2000b2c0"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "113km SSW of Kulumadau, Papua New Guinea",
        "time": 1507331102840,
        "updated": 1507423852040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2ba",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2ba.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b2ba",
        "ids": ",us2000b2ba,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.165,
        "rms": 0.64,
        "gap": 135,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 113km SSW of Kulumadau, Papua New Guinea"
      },
      "geometry": {"type": "Point", "coordinates": [152.3636, -10.0109, 10]},
      "id": "us2000b2ba"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "15km SE of Sary-Tash, Kyrgyzstan",
        "time": 1507331091160,
        "updated": 1507332618040,
        "tz": 360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2b9",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2b9.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 271,
        "net": "us",
        "code": "2000b2b9",
        "ids": ",us2000b2b9,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.001,
        "rms": 0.92,
        "gap": 175,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 15km SE of Sary-Tash, Kyrgyzstan"
      },
      "geometry": {"type": "Point", "coordinates": [73.3529, 39.6124, 10]},
      "id": "us2000b2b9"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "125km W of Iwanai, Japan",
        "time": 1507329021540,
        "updated": 1507331734040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2av",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2av.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b2av",
        "ids": ",us2000b2av,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.718,
        "rms": 0.76,
        "gap": 53,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 125km W of Iwanai, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [138.9649, 43.0121, 217.94]},
      "id": "us2000b2av"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "42km SSW of Pagan, Northern Mariana Islands",
        "time": 1507325144410,
        "updated": 1507327453040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b29t",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b29t.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b29t",
        "ids": ",us2000b29t,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.2,
        "rms": 0.49,
        "gap": 105,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 42km SSW of Pagan, Northern Mariana Islands"
      },
      "geometry": {"type": "Point", "coordinates": [145.6471, 17.7456, 196.33]},
      "id": "us2000b29t"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "49km SE of Clifton, Arizona",
        "time": 1507324395860,
        "updated": 1507422939040,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2ab",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2ab.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "us",
        "code": "2000b2ab",
        "ids": ",us2000b2ab,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.268,
        "rms": 0.88,
        "gap": 85,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 49km SE of Clifton, Arizona"
      },
      "geometry": {"type": "Point", "coordinates": [-108.8949, 32.7663, 5]},
      "id": "us2000b2ab"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "48km SW of Delta Junction, Alaska",
        "time": 1507317554328,
        "updated": 1507389294040,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16991058",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16991058.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16991058",
        "ids": ",ak16991058,us2000b279,",
        "sources": ",ak,us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.9,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 48km SW of Delta Junction, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-146.3172, 63.6837, 3.7]},
      "id": "ak16991058"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "92km W of Port-aux-Francais, French Southern Territories",
        "time": 1507315424010,
        "updated": 1507388057040,
        "tz": 300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b26p",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b26p.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b26p",
        "ids": ",us2000b26p,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.832,
        "rms": 0.41,
        "gap": 67,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 92km W of Port-aux-Francais, French Southern Territories"
      },
      "geometry": {"type": "Point", "coordinates": [68.9568, -49.2119, 13.54]},
      "id": "us2000b26p"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "95km NNW of Ngamring, China",
        "time": 1507311862190,
        "updated": 1507387817040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b260",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b260.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b260",
        "ids": ",us2000b260,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.815,
        "rms": 0.76,
        "gap": 93,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 95km NNW of Ngamring, China"
      },
      "geometry": {"type": "Point", "coordinates": [86.7487, 30.0165, 10]},
      "id": "us2000b260"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.5,
        "place": "Tristan da Cunha region",
        "time": 1507311683180,
        "updated": 1507387246758,
        "tz": -60,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b25h",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b25h.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": 2.15,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 465,
        "net": "us",
        "code": "2000b25h",
        "ids": ",us2000b25h,",
        "sources": ",us,",
        "types": ",geoserve,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 3.146,
        "rms": 0.66,
        "gap": 41,
        "magType": "mwb",
        "type": "earthquake",
        "title": "M 5.5 - Tristan da Cunha region"
      },
      "geometry": {"type": "Point", "coordinates": [-15.5503, -35.3171, 10]},
      "id": "us2000b25h"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "244km ESE of Ishinomaki, Japan",
        "time": 1507309684550,
        "updated": 1507385109065,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b24c",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b24c.geojsonp",
        "felt": 2,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b24c",
        "ids": ",us2000b24c,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.418,
        "rms": 1.08,
        "gap": 148,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 244km ESE of Ishinomaki, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [143.7841, 37.4191, 31.5]},
      "id": "us2000b24c"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.8,
        "place": "44km SW of Redoubt Volcano, Alaska",
        "time": 1507302735109,
        "updated": 1507303211660,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16990501",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16990501.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 121,
        "net": "ak",
        "code": "16990501",
        "ids": ",ak16990501,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.96,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.8 - 44km SW of Redoubt Volcano, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-153.2441, 60.1679, 148.9]},
      "id": "ak16990501"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.4,
        "place": "28km ENE of Iwaki, Japan",
        "time": 1507301800580,
        "updated": 1507600884027,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b20f",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b20f.geojsonp",
        "felt": 172,
        "cdi": 5.6,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 545,
        "net": "us",
        "code": "2000b20f",
        "ids": ",us2000b20f,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.833,
        "rms": 1.09,
        "gap": 130,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.4 - 28km ENE of Iwaki, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [141.1969, 37.0997, 47.42]},
      "id": "us2000b20f"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "65km E of Maneadero, B.C., MX",
        "time": 1507301676460,
        "updated": 1507305274921,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38020392",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38020392.geojsonp",
        "felt": 1,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "ci",
        "code": "38020392",
        "ids": ",ci38020392,",
        "sources": ",ci,",
        "types": ",dyfi,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 12,
        "dmin": 0.241,
        "rms": 0.19,
        "gap": 161,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 65km E of Maneadero, B.C., MX"
      },
      "geometry": {"type": "Point", "coordinates": [-115.8941667, 31.614, 5.89]},
      "id": "ci38020392"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.1,
        "place": "258km E of Port Blair, India",
        "time": 1507298433140,
        "updated": 1507306633050,
        "tz": 360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1zv",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1zv.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 400,
        "net": "us",
        "code": "2000b1zv",
        "ids": ",us2000b1zv,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.33,
        "rms": 1.27,
        "gap": 118,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.1 - 258km E of Port Blair, India"
      },
      "geometry": {"type": "Point", "coordinates": [95.0977, 12.0039, 21.82]},
      "id": "us2000b1zv"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.2,
        "place": "73km WSW of Chirovanga, Solomon Islands",
        "time": 1507289341850,
        "updated": 1507299340040,
        "tz": 660,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1xz",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1xz.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 1,
        "sig": 416,
        "net": "us",
        "code": "2000b1xz",
        "ids": ",us2000b1xz,",
        "sources": ",us,",
        "types": ",geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 4.604,
        "rms": 0.71,
        "gap": 54,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.2 - 73km WSW of Chirovanga, Solomon Islands"
      },
      "geometry": {"type": "Point", "coordinates": [155.9405, -6.8684, 106.51]},
      "id": "us2000b1xz"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3,
        "place": "56km E of Amatignak Island, Alaska",
        "time": 1507285562299,
        "updated": 1507314031481,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16990167",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16990167.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 138,
        "net": "ak",
        "code": "16990167",
        "ids": ",ak16990167,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.4,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.0 - 56km E of Amatignak Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-178.2949, 51.2318, 28]},
      "id": "ak16990167"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.2,
        "place": "67km NNW of Ruby, Alaska",
        "time": 1507285408267,
        "updated": 1507286352026,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16990162",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16990162.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 158,
        "net": "ak",
        "code": "16990162",
        "ids": ",ak16990162,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.68,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.2 - 67km NNW of Ruby, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-156.0402, 65.2966, 0.1]},
      "id": "ak16990162"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "45km NNE of Palu, Indonesia",
        "time": 1507281825250,
        "updated": 1507288356040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1xd",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1xd.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b1xd",
        "ids": ",us2000b1xd,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.79,
        "rms": 0.89,
        "gap": 132,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 45km NNE of Palu, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [119.9639, -0.4925, 44.07]},
      "id": "us2000b1xd"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.94,
        "place": "33km WSW of Captain Cook, Hawaii",
        "time": 1507279304370,
        "updated": 1507322964844,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61935091",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61935091.geojsonp",
        "felt": 1,
        "cdi": 1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 133,
        "net": "hv",
        "code": "61935091",
        "ids": ",hv61935091,",
        "sources": ",hv,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 52,
        "dmin": 0.3055,
        "rms": 0.23,
        "gap": 253,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 33km WSW of Captain Cook, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-156.2205, 19.3803333, 14.051]},
      "id": "hv61935091"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 6,
        "place": "255km ESE of Ishinomaki, Japan",
        "time": 1507276773110,
        "updated": 1507553354258,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1v8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1v8.geojsonp",
        "felt": 109,
        "cdi": 5.4,
        "mmi": 2.8,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 613,
        "net": "us",
        "code": "2000b1v8",
        "ids": ",us2000b1v8,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 2.539,
        "rms": 0.9,
        "gap": 29,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 6.0 - 255km ESE of Ishinomaki, Japan"
      },
      "geometry": {"type": "Point", "coordinates": [143.9537, 37.485, 10]},
      "id": "us2000b1v8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.1,
        "place": "92km WNW of Skagway, Alaska",
        "time": 1507274375943,
        "updated": 1507274691030,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16989976",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16989976.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 148,
        "net": "ak",
        "code": "16989976",
        "ids": ",ak16989976,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.81,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.1 - 92km WNW of Skagway, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-136.7235, 59.8808, 0]},
      "id": "ak16989976"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "156km ESE of Rota, Northern Mariana Islands",
        "time": 1507273552100,
        "updated": 1507274632040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1v0",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1v0.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b1v0",
        "ids": ",us2000b1v0,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.716,
        "rms": 1.01,
        "gap": 66,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 156km ESE of Rota, Northern Mariana Islands"
      },
      "geometry": {"type": "Point", "coordinates": [146.6145, 13.8504, 10]},
      "id": "us2000b1v0"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.3,
        "place": "24km SE of Baie-Comeau, Canada",
        "time": 1507270603000,
        "updated": 1507354760040,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b2dh",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b2dh.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 168,
        "net": "us",
        "code": "2000b2dh",
        "ids": ",us2000b2dh,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.38,
        "gap": null,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 3.3 - 24km SE of Baie-Comeau, Canada"
      },
      "geometry": {"type": "Point", "coordinates": [-67.92, 49.06, 22]},
      "id": "us2000b2dh"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "12km E of Soda Springs, Idaho",
        "time": 1507269804040,
        "updated": 1507315808480,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1um",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1um.geojsonp",
        "felt": 2,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 113,
        "net": "us",
        "code": "2000b1um",
        "ids": ",us2000b1um,uu60251362,",
        "sources": ",us,uu,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.011,
        "rms": 0.2,
        "gap": 104,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 12km E of Soda Springs, Idaho"
      },
      "geometry": {"type": "Point", "coordinates": [-111.4493, 42.6517, 7.67]},
      "id": "us2000b1um"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "37km S of Little Sitkin Island, Alaska",
        "time": 1507269388630,
        "updated": 1507274704040,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1un",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1un.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b1un",
        "ids": ",us2000b1un,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.554,
        "rms": 0.8,
        "gap": 179,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 37km S of Little Sitkin Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [178.4985, 51.6139, 71.76]},
      "id": "us2000b1un"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "36km WSW of Villa Yapacani, Bolivia",
        "time": 1507265974560,
        "updated": 1507299092552,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1u8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1u8.geojsonp",
        "felt": 1,
        "cdi": 4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b1u8",
        "ids": ",us2000b1u8,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.039,
        "rms": 1,
        "gap": 42,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 36km WSW of Villa Yapacani, Bolivia"
      },
      "geometry": {"type": "Point", "coordinates": [-64.1261, -17.5702, 36.33]},
      "id": "us2000b1u8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "142km E of Samarai, Papua New Guinea",
        "time": 1507262599510,
        "updated": 1507263791040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1tr",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1tr.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "2000b1tr",
        "ids": ",us2000b1tr,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.824,
        "rms": 0.7,
        "gap": 79,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - 142km E of Samarai, Papua New Guinea"
      },
      "geometry": {"type": "Point", "coordinates": [151.9528, -10.3953, 10]},
      "id": "us2000b1tr"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.97,
        "place": "142km W of Westhaven-Moonstone, California",
        "time": 1507257072490,
        "updated": 1507332302081,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72905101",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72905101.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 136,
        "net": "nc",
        "code": "72905101",
        "ids": ",nc72905101,",
        "sources": ",nc,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 24,
        "dmin": 1.331,
        "rms": 0.05,
        "gap": 276,
        "magType": "md",
        "type": "earthquake",
        "title": "M 3.0 - 142km W of Westhaven-Moonstone, California"
      },
      "geometry": {"type": "Point", "coordinates": [-125.7771667, 41.2375, 7.51]},
      "id": "nc72905101"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "Central Mid-Atlantic Ridge",
        "time": 1507255428530,
        "updated": 1507321069040,
        "tz": -120,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1t0",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1t0.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "2000b1t0",
        "ids": ",us2000b1t0,",
        "sources": ",us,",
        "types": ",geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 14.013,
        "rms": 0.96,
        "gap": 99,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - Central Mid-Atlantic Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [-25.496, 0.9934, 10]},
      "id": "us2000b1t0"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "115km SSW of Kulumadau, Papua New Guinea",
        "time": 1507253577740,
        "updated": 1507254968040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1sv",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1sv.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b1sv",
        "ids": ",us2000b1sv,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.985,
        "rms": 0.63,
        "gap": 199,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 115km SSW of Kulumadau, Papua New Guinea"
      },
      "geometry": {"type": "Point", "coordinates": [152.1867, -9.9486, 10]},
      "id": "us2000b1sv"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4,
        "place": "3km N of Coquimbo, Chile",
        "time": 1507248914000,
        "updated": 1507423493040,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1s9",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1s9.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 246,
        "net": "us",
        "code": "2000b1s9",
        "ids": ",us2000b1s9,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 1.24,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 4.0 - 3km N of Coquimbo, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-71.348, -29.925, 48.8]},
      "id": "us2000b1s9"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.5,
        "place": "150km NNW of Chirikof Island, Alaska",
        "time": 1507246852668,
        "updated": 1507608302040,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak17001426",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak17001426.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 96,
        "net": "ak",
        "code": "17001426",
        "ids": ",ak17001426,us2000b3bi,",
        "sources": ",ak,us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.49,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 150km NNW of Chirikof Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-156.6733, 57.047, 36.6]},
      "id": "ak17001426"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.81,
        "place": "24km SE of Mammoth Lakes, California",
        "time": 1507244867710,
        "updated": 1507264983497,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72905011",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72905011.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 121,
        "net": "nc",
        "code": "72905011",
        "ids": ",nc72905011,",
        "sources": ",nc,",
        "types": ",focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 47,
        "dmin": 0.07238,
        "rms": 0.05,
        "gap": 71,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.8 - 24km SE of Mammoth Lakes, California"
      },
      "geometry": {"type": "Point", "coordinates": [-118.8105, 37.472, 6.12]},
      "id": "nc72905011"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "152km NNW of Farallon de Pajaros, Northern Mariana Islands",
        "time": 1507242807430,
        "updated": 1507246663040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1rh",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1rh.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b1rh",
        "ids": ",us2000b1rh,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.637,
        "rms": 0.71,
        "gap": 45,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 152km NNW of Farallon de Pajaros, Northern Mariana Islands"
      },
      "geometry": {"type": "Point", "coordinates": [144.6063, 21.8848, 100.39]},
      "id": "us2000b1rh"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "18km SE of Soda Springs, Idaho",
        "time": 1507239146260,
        "updated": 1507240537040,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1px",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1px.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "us",
        "code": "2000b1px",
        "ids": ",uu60251312,us2000b1px,",
        "sources": ",uu,us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.037,
        "rms": 0.42,
        "gap": 43,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 18km SE of Soda Springs, Idaho"
      },
      "geometry": {"type": "Point", "coordinates": [-111.4355, 42.5495, 8.32]},
      "id": "us2000b1px"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.14,
        "place": "252km W of Ferndale, California",
        "time": 1507233758820,
        "updated": 1507265883518,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72904936",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72904936.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 152,
        "net": "nc",
        "code": "72904936",
        "ids": ",nc72904936,",
        "sources": ",nc,",
        "types": ",geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 8,
        "dmin": 2.205,
        "rms": 0.23,
        "gap": 352,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.1 - 252km W of Ferndale, California"
      },
      "geometry": {"type": "Point", "coordinates": [-127.192, 40.1631667, 11.62]},
      "id": "nc72904936"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "55km W of Piru, Indonesia",
        "time": 1507219416430,
        "updated": 1507298634040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1ip",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1ip.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b1ip",
        "ids": ",us2000b1ip,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.549,
        "rms": 0.94,
        "gap": 76,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 55km W of Piru, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [127.6953, -3.0506, 46.98]},
      "id": "us2000b1ip"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "60km SSW of Adak, Alaska",
        "time": 1507210486813,
        "updated": 1507596574939,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak17001390",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak17001390.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "17001390",
        "ids": ",ak17001390,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.33,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 60km SSW of Adak, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-177.0616, 51.3942, 32.8]},
      "id": "ak17001390"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.55,
        "place": "12km ENE of Ocotillo Wells, CA",
        "time": 1507209518050,
        "updated": 1507225903800,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ci38019464",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ci38019464.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 100,
        "net": "ci",
        "code": "38019464",
        "ids": ",ci38019464,",
        "sources": ",ci,",
        "types": ",focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 82,
        "dmin": 0.1023,
        "rms": 0.2,
        "gap": 36,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 12km ENE of Ocotillo Wells, CA"
      },
      "geometry": {"type": "Point", "coordinates": [-116.0106667, 33.1796667, 8.09]},
      "id": "ci38019464"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.8,
        "place": "47km S of Tanaga Volcano, Alaska",
        "time": 1507206068075,
        "updated": 1507596573249,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16989481",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16989481.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 121,
        "net": "ak",
        "code": "16989481",
        "ids": ",ak16989481,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.61,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.8 - 47km S of Tanaga Volcano, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-178.1434, 51.4588, 13.1]},
      "id": "ak16989481"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.64,
        "place": "4km WNW of The Geysers, California",
        "time": 1507204013350,
        "updated": 1507267742596,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72904681",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72904681.geojsonp",
        "felt": 4,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 109,
        "net": "nc",
        "code": "72904681",
        "ids": ",nc72904681,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 68,
        "dmin": 0.01232,
        "rms": 0.07,
        "gap": 28,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.6 - 4km WNW of The Geysers, California"
      },
      "geometry": {"type": "Point", "coordinates": [-122.8035, 38.7913333, 3.29]},
      "id": "nc72904681"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "4km NW of San Pedro, Philippines",
        "time": 1507202248310,
        "updated": 1507264841040,
        "tz": 480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1f7",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1f7.geojsonp",
        "felt": 2,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 385,
        "net": "us",
        "code": "2000b1f7",
        "ids": ",us2000b1f7,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.947,
        "rms": 1.06,
        "gap": 47,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - 4km NW of San Pedro, Philippines"
      },
      "geometry": {"type": "Point", "coordinates": [126.4874, 7.3643, 10]},
      "id": "us2000b1f7"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "39km W of Ramhormoz, Iran",
        "time": 1507198268580,
        "updated": 1507202433040,
        "tz": 210,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1dj",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1dj.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b1dj",
        "ids": ",us2000b1dj,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.34,
        "rms": 0.85,
        "gap": 64,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 39km W of Ramhormoz, Iran"
      },
      "geometry": {"type": "Point", "coordinates": [49.1899, 31.277, 10]},
      "id": "us2000b1dj"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.63,
        "place": "42km NW of Big Timber, Montana",
        "time": 1507197824690,
        "updated": 1507252302017,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/mb80259269",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/mb80259269.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 107,
        "net": "mb",
        "code": "80259269",
        "ids": ",mb80259269,",
        "sources": ",mb,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 19,
        "dmin": 0.497,
        "rms": 0.18,
        "gap": 115,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 42km NW of Big Timber, Montana"
      },
      "geometry": {"type": "Point", "coordinates": [-110.3173333, 46.1263333, 14.98]},
      "id": "mb80259269"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "South of the Fiji Islands",
        "time": 1507196589420,
        "updated": 1507197653040,
        "tz": 720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1da",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1da.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b1da",
        "ids": ",us2000b1da,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 7.299,
        "rms": 0.87,
        "gap": 66,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - South of the Fiji Islands"
      },
      "geometry": {"type": "Point", "coordinates": [178.5051, -25.068, 564.41]},
      "id": "us2000b1da"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.4,
        "place": "37km E of Calama, Chile",
        "time": 1507191096920,
        "updated": 1507244524040,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b1c3",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b1c3.geojsonp",
        "felt": 5,
        "cdi": 4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 451,
        "net": "us",
        "code": "2000b1c3",
        "ids": ",us2000b1c3,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.37,
        "rms": 1.08,
        "gap": 52,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.4 - 37km E of Calama, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-68.5742, -22.4118, 112.87]},
      "id": "us2000b1c3"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.52,
        "place": "25km WNW of Hayfork, California",
        "time": 1507190856940,
        "updated": 1507262283488,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72904646",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72904646.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 98,
        "net": "nc",
        "code": "72904646",
        "ids": ",nc72904646,",
        "sources": ",nc,",
        "types": ",focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 25,
        "dmin": 0.1581,
        "rms": 0.08,
        "gap": 39,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 25km WNW of Hayfork, California"
      },
      "geometry": {"type": "Point", "coordinates": [-123.472, 40.6168333, 21.52]},
      "id": "nc72904646"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.61,
        "place": "5km NW of The Geysers, California",
        "time": 1507175806240,
        "updated": 1507263183434,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72904521",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72904521.geojsonp",
        "felt": 4,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 106,
        "net": "nc",
        "code": "72904521",
        "ids": ",nc72904521,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 56,
        "dmin": 0.0064,
        "rms": 0.07,
        "gap": 27,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.6 - 5km NW of The Geysers, California"
      },
      "geometry": {"type": "Point", "coordinates": [-122.792, 38.8138333, 3.02]},
      "id": "nc72904521"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "68km NNW of Kodiak Station, Alaska",
        "time": 1507169038607,
        "updated": 1507596854491,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16989295",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16989295.geojsonp",
        "felt": 3,
        "cdi": 2.2,
        "mmi": 3.17,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 1,
        "sig": 285,
        "net": "ak",
        "code": "16989295",
        "ids": ",ak16989295,at00oxbv2m,",
        "sources": ",ak,at,",
        "types": ",dyfi,geoserve,impact-link,losspager,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": null,
        "rms": 0.58,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 4.3 - 68km NNW of Kodiak Station, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-152.8635, 58.3613, 50]},
      "id": "ak16989295"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "32km NW of Fairview, Oklahoma",
        "time": 1507164698800,
        "updated": 1507278664375,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b190",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b190.geojsonp",
        "felt": 2,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "us",
        "code": "2000b190",
        "ids": ",us2000b190,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.037,
        "rms": 0.21,
        "gap": 74,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 2.6 - 32km NW of Fairview, Oklahoma"
      },
      "geometry": {"type": "Point", "coordinates": [-98.7663, 36.4461, 6.31]},
      "id": "us2000b190"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "39km SSW of Akutan, Alaska",
        "time": 1507162971389,
        "updated": 1507596559364,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16989282",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16989282.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16989282",
        "ids": ",ak16989282,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.23,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 39km SSW of Akutan, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-165.9195, 53.789, 71.1]},
      "id": "ak16989282"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.4,
        "place": "31km NW of Fairview, Oklahoma",
        "time": 1507162321850,
        "updated": 1507278567588,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b185",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b185.geojsonp",
        "felt": 3,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 178,
        "net": "us",
        "code": "2000b185",
        "ids": ",us2000b185,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.03,
        "rms": 0.29,
        "gap": 72,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 3.4 - 31km NW of Fairview, Oklahoma"
      },
      "geometry": {"type": "Point", "coordinates": [-98.755, 36.45, 7.23]},
      "id": "us2000b185"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "47km WNW of San Antonio de los Cobres, Argentina",
        "time": 1507156394080,
        "updated": 1507157447040,
        "tz": -180,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b16h",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b16h.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b16h",
        "ids": ",us2000b16h,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.691,
        "rms": 0.98,
        "gap": 37,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 47km WNW of San Antonio de los Cobres, Argentina"
      },
      "geometry": {"type": "Point", "coordinates": [-66.7169, -23.9861, 195.32]},
      "id": "us2000b16h"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.5,
        "place": "31km NW of Fairview, Oklahoma",
        "time": 1507154804460,
        "updated": 1507278413719,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b15z",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b15z.geojsonp",
        "felt": 3,
        "cdi": 2,
        "mmi": 3.77,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 189,
        "net": "us",
        "code": "2000b15z",
        "ids": ",us2000b15z,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 0.027,
        "rms": 0.29,
        "gap": 69,
        "magType": "mb_lg",
        "type": "earthquake",
        "title": "M 3.5 - 31km NW of Fairview, Oklahoma"
      },
      "geometry": {"type": "Point", "coordinates": [-98.7425, 36.4507, 4.85]},
      "id": "us2000b15z"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "62km SSE of San Francisco del Mar, Mexico",
        "time": 1507151144560,
        "updated": 1507152414040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b152",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b152.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 271,
        "net": "us",
        "code": "2000b152",
        "ids": ",us2000b152,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.93,
        "rms": 0.77,
        "gap": 187,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 62km SSE of San Francisco del Mar, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.5193, 15.6807, 43.81]},
      "id": "us2000b152"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 3.2,
        "place": "151km SSW of Chirikof Island, Alaska",
        "time": 1507149758758,
        "updated": 1507150112184,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16989132",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16989132.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 158,
        "net": "ak",
        "code": "16989132",
        "ids": ",ak16989132,",
        "sources": ",ak,",
        "types": ",geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.76,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 3.2 - 151km SSW of Chirikof Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-156.904, 54.6732, 0]},
      "id": "ak16989132"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.1,
        "place": "138km NE of San Jose del Cabo, Mexico",
        "time": 1507145834470,
        "updated": 1507160551040,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b12w",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b12w.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 259,
        "net": "us",
        "code": "2000b12w",
        "ids": ",us2000b12w,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 1.262,
        "rms": 0.84,
        "gap": 208,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.1 - 138km NE of San Jose del Cabo, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-108.5682, 23.7468, 10]},
      "id": "us2000b12w"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "Mid-Indian Ridge",
        "time": 1507142880510,
        "updated": 1507156127040,
        "tz": 300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us1000alvi",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us1000alvi.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "1000alvi",
        "ids": ",us1000alvi,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 6.218,
        "rms": 1.06,
        "gap": 75,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - Mid-Indian Ridge"
      },
      "geometry": {"type": "Point", "coordinates": [69.2314, -22.7343, 10]},
      "id": "us1000alvi"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "10km NE of San Jeronimo Ixtepec, Mexico",
        "time": 1507142721780,
        "updated": 1507154727321,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b11q",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b11q.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 285,
        "net": "us",
        "code": "2000b11q",
        "ids": ",us2000b11q,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.786,
        "rms": 1,
        "gap": 159,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 10km NE of San Jeronimo Ixtepec, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-95.0179, 16.6332, 10]},
      "id": "us2000b11q"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.71,
        "place": "3km ESE of Aromas, California",
        "time": 1507132718170,
        "updated": 1507598484279,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72904166",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72904166.geojsonp",
        "felt": 28,
        "cdi": 3.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 122,
        "net": "nc",
        "code": "72904166",
        "ids": ",nc72904166,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 70,
        "dmin": 0.01424,
        "rms": 0.08,
        "gap": 45,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.7 - 3km ESE of Aromas, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.6093333, 36.8815, 6.65]},
      "id": "nc72904166"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.4,
        "place": "41km SSW of San Francisco del Mar, Mexico",
        "time": 1507130270240,
        "updated": 1507153074040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0yw",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0yw.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 298,
        "net": "us",
        "code": "2000b0yw",
        "ids": ",us2000b0yw,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 3.209,
        "rms": 0.65,
        "gap": 181,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.4 - 41km SSW of San Francisco del Mar, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.7831, 15.8774, 9.59]},
      "id": "us2000b0yw"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.9,
        "place": "15km NE of Sangolqui, Ecuador",
        "time": 1507127377130,
        "updated": 1507163904401,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b14r",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b14r.geojsonp",
        "felt": 2,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 130,
        "net": "us",
        "code": "2000b14r",
        "ids": ",us2000b14r,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.309,
        "rms": 0.43,
        "gap": 153,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 15km NE of Sangolqui, Ecuador"
      },
      "geometry": {"type": "Point", "coordinates": [-78.3466, -0.2479, 10]},
      "id": "us2000b14r"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.3,
        "place": "127km SW of Tres Picos, Mexico",
        "time": 1507120048520,
        "updated": 1507122613040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0xy",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0xy.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 284,
        "net": "us",
        "code": "2000b0xy",
        "ids": ",us2000b0xy,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.417,
        "rms": 0.76,
        "gap": 169,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.3 - 127km SW of Tres Picos, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.219, 14.9246, 35]},
      "id": "us2000b0xy"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "45km WNW of Haines Junction, Canada",
        "time": 1507115904863,
        "updated": 1507141690163,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16988943",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16988943.geojsonp",
        "felt": 1,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "automatic",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16988943",
        "ids": ",ak16988943,",
        "sources": ",ak,",
        "types": ",dyfi,geoserve,origin,",
        "nst": null,
        "dmin": null,
        "rms": 0.64,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 45km WNW of Haines Junction, Canada"
      },
      "geometry": {"type": "Point", "coordinates": [-138.3287, 60.8439, 0]},
      "id": "ak16988943"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.46,
        "place": "15km SE of Lincoln, Montana",
        "time": 1507108546600,
        "updated": 1507132645705,
        "tz": -420,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/mb80259134",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/mb80259134.geojsonp",
        "felt": 3,
        "cdi": 2.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 94,
        "net": "mb",
        "code": "80259134",
        "ids": ",mb80259134,",
        "sources": ",mb,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 22,
        "dmin": 0.05,
        "rms": 0.14,
        "gap": 68,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 15km SE of Lincoln, Montana"
      },
      "geometry": {"type": "Point", "coordinates": [-112.5278333, 46.8678333, 13.28]},
      "id": "mb80259134"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.8,
        "place": "101km SSW of Tres Picos, Mexico",
        "time": 1507102453200,
        "updated": 1507103274040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0vg",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0vg.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 354,
        "net": "us",
        "code": "2000b0vg",
        "ids": ",us2000b0vg,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.322,
        "rms": 1.13,
        "gap": 146,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.8 - 101km SSW of Tres Picos, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.0265, 15.081, 39.52]},
      "id": "us2000b0vg"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.54,
        "place": "13km S of Honoka'a, Hawaii",
        "time": 1507098254160,
        "updated": 1507158192880,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61932126",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61932126.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 99,
        "net": "hv",
        "code": "61932126",
        "ids": ",hv61932126,",
        "sources": ",hv,",
        "types": ",geoserve,origin,phase-data,",
        "nst": 10,
        "dmin": 0.1419,
        "rms": 0.07,
        "gap": 140,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.5 - 13km S of Honoka'a, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.471, 19.9581667, 34.056]},
      "id": "hv61932126"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.7,
        "place": "29km N of Pagan, Northern Mariana Islands",
        "time": 1507093737820,
        "updated": 1507095423040,
        "tz": 600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0ue",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0ue.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 340,
        "net": "us",
        "code": "2000b0ue",
        "ids": ",us2000b0ue,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.833,
        "rms": 0.78,
        "gap": 80,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.7 - 29km N of Pagan, Northern Mariana Islands"
      },
      "geometry": {"type": "Point", "coordinates": [145.7448, 18.3756, 172.11]},
      "id": "us2000b0ue"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5,
        "place": "72km ESE of L'Esperance Rock, New Zealand",
        "time": 1507087351060,
        "updated": 1507089184040,
        "tz": -720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0th",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0th.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 385,
        "net": "us",
        "code": "2000b0th",
        "ids": ",us2000b0th,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 16.681,
        "rms": 0.99,
        "gap": 109,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.0 - 72km ESE of L'Esperance Rock, New Zealand"
      },
      "geometry": {"type": "Point", "coordinates": [-178.1517, -31.5827, 35.55]},
      "id": "us2000b0th"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.2,
        "place": "21km S of San Pedro de Atacama, Chile",
        "time": 1507086128100,
        "updated": 1507269959080,
        "tz": -240,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0t5",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0t5.geojsonp",
        "felt": 2,
        "cdi": 3.8,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 417,
        "net": "us",
        "code": "2000b0t5",
        "ids": ",us2000b0t5,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,moment-tensor,origin,phase-data,",
        "nst": null,
        "dmin": 0.154,
        "rms": 1,
        "gap": 52,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.2 - 21km S of San Pedro de Atacama, Chile"
      },
      "geometry": {"type": "Point", "coordinates": [-68.1988, -23.1056, 126.96]},
      "id": "us2000b0t5"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "4km W of Gomez, Panama",
        "time": 1507074238890,
        "updated": 1507121902699,
        "tz": -300,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0rt",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0rt.geojsonp",
        "felt": 7,
        "cdi": 3.2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 274,
        "net": "us",
        "code": "2000b0rt",
        "ids": ",us2000b0rt,",
        "sources": ",us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.097,
        "rms": 1.14,
        "gap": 119,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 4km W of Gomez, Panama"
      },
      "geometry": {"type": "Point", "coordinates": [-82.7745, 8.5663, 30.59]},
      "id": "us2000b0rt"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.2,
        "place": "65km SW of Paredon, Mexico",
        "time": 1507068153470,
        "updated": 1507069105040,
        "tz": -360,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0q2",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0q2.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 271,
        "net": "us",
        "code": "2000b0q2",
        "ids": ",us2000b0q2,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 2.713,
        "rms": 0.95,
        "gap": 208,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.2 - 65km SW of Paredon, Mexico"
      },
      "geometry": {"type": "Point", "coordinates": [-94.2992, 15.6198, 60.2]},
      "id": "us2000b0q2"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "144km NNW of Chirikof Island, Alaska",
        "time": 1507065657270,
        "updated": 1507408727663,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16988519",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16988519.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "ak",
        "code": "16988519",
        "ids": ",ak16988519,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.29,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 144km NNW of Chirikof Island, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-156.2687, 57.0749, 82.1]},
      "id": "ak16988519"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.7,
        "place": "North Atlantic Ocean",
        "time": 1507063144760,
        "updated": 1507136537524,
        "tz": -180,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0nr",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0nr.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": 0,
        "alert": "green",
        "status": "reviewed",
        "tsunami": 0,
        "sig": 500,
        "net": "us",
        "code": "2000b0nr",
        "ids": ",us2000b0nr,",
        "sources": ",us,",
        "types": ",geoserve,losspager,moment-tensor,origin,phase-data,shakemap,",
        "nst": null,
        "dmin": 8.917,
        "rms": 0.76,
        "gap": 20,
        "magType": "mww",
        "type": "earthquake",
        "title": "M 5.7 - North Atlantic Ocean"
      },
      "geometry": {"type": "Point", "coordinates": [-49.3194, 13.4552, 10]},
      "id": "us2000b0nr"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.49,
        "place": "2km NNW of The Geysers, California",
        "time": 1507062907080,
        "updated": 1507097343483,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72903771",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72903771.geojsonp",
        "felt": 2,
        "cdi": 3.1,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 96,
        "net": "nc",
        "code": "72903771",
        "ids": ",nc72903771,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 55,
        "dmin": 0.01741,
        "rms": 0.05,
        "gap": 43,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.5 - 2km NNW of The Geysers, California"
      },
      "geometry": {"type": "Point", "coordinates": [-122.767, 38.7991667, 0.51]},
      "id": "nc72903771"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "49km ENE of Nikol'skoye, Russia",
        "time": 1507061510710,
        "updated": 1507133482040,
        "tz": 660,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0n8",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0n8.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b0n8",
        "ids": ",us2000b0n8,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 5.282,
        "rms": 0.61,
        "gap": 125,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 49km ENE of Nikol'skoye, Russia"
      },
      "geometry": {"type": "Point", "coordinates": [166.7231, 55.3488, 28.06]},
      "id": "us2000b0n8"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 5.2,
        "place": "189km NNW of Visokoi Island, South Georgia and the South Sandwich Islands",
        "time": 1507057466210,
        "updated": 1507130420040,
        "tz": -120,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0lw",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0lw.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 416,
        "net": "us",
        "code": "2000b0lw",
        "ids": ",us2000b0lw,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 4.539,
        "rms": 0.67,
        "gap": 47,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 5.2 - 189km NNW of Visokoi Island, South Georgia and the South Sandwich Islands"
      },
      "geometry": {"type": "Point", "coordinates": [-28.8364, -55.2702, 10]},
      "id": "us2000b0lw"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.65,
        "place": "9km WSW of Volcano, Hawaii",
        "time": 1507055057800,
        "updated": 1507129617040,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61931361",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61931361.geojsonp",
        "felt": 2,
        "cdi": 2,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 108,
        "net": "hv",
        "code": "61931361",
        "ids": ",hv61931361,us2000b0la,",
        "sources": ",hv,us,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 52,
        "dmin": 0.01515,
        "rms": 0.09,
        "gap": 41,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 9km WSW of Volcano, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.324, 19.4066667, 7.018]},
      "id": "hv61931361"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "52km W of Abepura, Indonesia",
        "time": 1507050191000,
        "updated": 1507128154040,
        "tz": 540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0jm",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0jm.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b0jm",
        "ids": ",us2000b0jm,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 7.862,
        "rms": 0.58,
        "gap": 102,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 52km W of Abepura, Indonesia"
      },
      "geometry": {"type": "Point", "coordinates": [140.1126, -2.5625, 21.57]},
      "id": "us2000b0jm"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.58,
        "place": "11km SW of Ridgemark, California",
        "time": 1507046582120,
        "updated": 1507141392502,
        "tz": -480,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/nc72903666",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/nc72903666.geojsonp",
        "felt": 6,
        "cdi": 2.7,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "nc",
        "code": "72903666",
        "ids": ",nc72903666,",
        "sources": ",nc,",
        "types": ",dyfi,focal-mechanism,geoserve,nearby-cities,origin,phase-data,scitech-link,",
        "nst": 56,
        "dmin": 0.01066,
        "rms": 0.1,
        "gap": 60,
        "magType": "md",
        "type": "earthquake",
        "title": "M 2.6 - 11km SW of Ridgemark, California"
      },
      "geometry": {"type": "Point", "coordinates": [-121.4643333, 36.7508333, 7.57]},
      "id": "nc72903666"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "73km WSW of Anchor Point, Alaska",
        "time": 1507043705635,
        "updated": 1507408716476,
        "tz": -540,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16988345",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16988345.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 112,
        "net": "ak",
        "code": "16988345",
        "ids": ",ak16988345,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.46,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 73km WSW of Anchor Point, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-153.0117, 59.5043, 89]},
      "id": "ak16988345"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.7,
        "place": "34km SSW of Tanaga Volcano, Alaska",
        "time": 1507042999732,
        "updated": 1507408715663,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/ak16988343",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/ak16988343.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 112,
        "net": "ak",
        "code": "16988343",
        "ids": ",ak16988343,",
        "sources": ",ak,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": null,
        "rms": 0.62,
        "gap": null,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.7 - 34km SSW of Tanaga Volcano, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-178.3915, 51.6134, 9.1]},
      "id": "ak16988343"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.87,
        "place": "12km ESE of Honoka'a, Hawaii",
        "time": 1507040757870,
        "updated": 1507066051347,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/hv61931251",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/hv61931251.geojsonp",
        "felt": 6,
        "cdi": 3.4,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 129,
        "net": "hv",
        "code": "61931251",
        "ids": ",hv61931251,",
        "sources": ",hv,",
        "types": ",dyfi,geoserve,origin,phase-data,",
        "nst": 46,
        "dmin": 0.1272,
        "rms": 0.18,
        "gap": 154,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.9 - 12km ESE of Honoka'a, Hawaii"
      },
      "geometry": {"type": "Point", "coordinates": [-155.3708333, 20.0273333, 12.259]},
      "id": "hv61931251"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.6,
        "place": "32km SE of Waiouru, New Zealand",
        "time": 1507040383740,
        "updated": 1507043683040,
        "tz": 720,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0gr",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0gr.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 326,
        "net": "us",
        "code": "2000b0gr",
        "ids": ",us2000b0gr,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.65,
        "rms": 1.26,
        "gap": 126,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.6 - 32km SE of Waiouru, New Zealand"
      },
      "geometry": {"type": "Point", "coordinates": [175.9616, -39.6706, 78.62]},
      "id": "us2000b0gr"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 2.6,
        "place": "57km S of Tanaga Volcano, Alaska",
        "time": 1507038712390,
        "updated": 1507408712656,
        "tz": -600,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0k7",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0k7.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 104,
        "net": "us",
        "code": "2000b0k7",
        "ids": ",ak16988329,us2000b0k7,",
        "sources": ",ak,us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.43,
        "rms": 0.57,
        "gap": 201,
        "magType": "ml",
        "type": "earthquake",
        "title": "M 2.6 - 57km S of Tanaga Volcano, Alaska"
      },
      "geometry": {"type": "Point", "coordinates": [-178.1971, 51.3674, 18.8]},
      "id": "us2000b0k7"
    }, {
      "type": "Feature",
      "properties": {
        "mag": 4.5,
        "place": "74km SSE of Phek, India",
        "time": 1507038514350,
        "updated": 1507042863040,
        "tz": 390,
        "url": "https://earthquake.usgs.gov/earthquakes/eventpage/us2000b0gm",
        "detail": "https://earthquake.usgs.gov/earthquakes/feed/v1.0/detail/us2000b0gm.geojsonp",
        "felt": null,
        "cdi": null,
        "mmi": null,
        "alert": null,
        "status": "reviewed",
        "tsunami": 0,
        "sig": 312,
        "net": "us",
        "code": "2000b0gm",
        "ids": ",us2000b0gm,",
        "sources": ",us,",
        "types": ",geoserve,origin,phase-data,",
        "nst": null,
        "dmin": 0.927,
        "rms": 0.81,
        "gap": 72,
        "magType": "mb",
        "type": "earthquake",
        "title": "M 4.5 - 74km SSE of Phek, India"
      },
      "geometry": {"type": "Point", "coordinates": [94.7848, 25.0488, 74.86]},
      "id": "us2000b0gm"
    }];
  }

  componentDidMount() {
    this.map = new google.maps.Map(this.refs.container, {
      zoom: 16,
      center: {lat: 43.6516447, lng: -79.384293},
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      styles: [
        {
          featureType: 'poi.attraction',
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: 'poi.park',
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: 'poi.place_of_worship',
          stylers: [{ visibility: "off" }]
        },
        {
          featureType: 'poi.place_of_worship',
          stylers: [{ visibility: "off" }]
        }
      ]
    });

    var infowindow = new google.maps.InfoWindow({
      content: 'test'
    });


    const circles = data.map(d => {
      if(d[6]) {
        let e = parseFloat(d[5]);
        if(e > 100) e = 100;
        const c = {
          strokeColor: 'white',
          strokeWeight: 0.5,
          fillColor: this.hsv2rgb(Math.floor((100 - e) * 120 / 100), 1, 1),
          fillOpacity: .6,
          map: this.map,
          center: {lat: d[6].location.lat, lng: d[6].location.lng},
          radius: 30,
          data: d
        };
        return new google.maps.Circle(c);
      }
      // return new google.maps.LatLng(d.geometry.coordinates[1], d.geometry.coordinates[0]);
    });

    circles.forEach(circle => {
      if(circle) {
        circle.addListener('click', function(event) {
          infowindow.setContent(`<div style="display:flex; flex-direction: column;"><div>${this.data[0]}</div><div>${this.data[1]} ${this.data[2]}</div><div>Total Floor Area(sqft): ${this.data[3]}</div><div>Electricity(kWh): ${this.data[4]}</div><div>Energy Intensity(ekWh/sqft): ${this.data[5]}</div></div>`);
          infowindow.setPosition(event.latLng);
          infowindow.open(this.map);
        });
      }
    });

    // var heatmap = new google.maps.visualization.HeatmapLayer({
    //   data: h,
    //   dissipating: false,
    //   map: this.map
    // });

    // this.map.data.setStyle(function(feature) {
    //   var magnitude = feature.getProperty('mag');
    //   return {
    //     icon: getCircle(magnitude)
    //   };
    // });
    //
    // function getCircle(magnitude) {
    //   return {
    //     path: google.maps.SymbolPath.CIRCLE,
    //     fillColor: 'red',
    //     fillOpacity: .2,
    //     scale: Math.pow(2, magnitude) / 2,
    //     strokeColor: 'white',
    //     strokeWeight: .5
    //   };
    // }



    this.count = 0;
    this.geocoder = new google.maps.Geocoder();

    // this.getData();
  }

  getData() {
    if(data[this.count][6] == null) {
      console.log('searching for ' + data[this.count][1] + " " + data[this.count][2]);
      this.geocoder.geocode({address: data[this.count][1] + " " + data[this.count][2]}, (results, status) => {
        if (status == 'OK') {
          console.log(`request ${this.count} OK`);
          if(results.length > 0) {
            data[this.count].push(results[0].geometry);
          }
        } else {
          console.log('Geocode was not successful for the following reason: ' + status);
        }

        if(this.count < data.length ) {
          setTimeout(() => {
            this.count++;
            this.getData();
          }, 2000);
        } else {
          console.log("done");
          console.log(JSON.stringify(data));
        }
      });
    } else {
      this.count++;
      this.getData();
    }
  }

  hsv2rgb(h, s, v) {
    var rgb, i, data = [];
    if (s === 0) {
      rgb = [v,v,v];
    } else {
      h = h / 60;
      i = Math.floor(h);
      data = [v*(1-s), v*(1-s*(h-i)), v*(1-s*(1-(h-i)))];
      switch(i) {
        case 0:
          rgb = [v, data[2], data[0]];
          break;
        case 1:
          rgb = [data[1], v, data[0]];
          break;
        case 2:
          rgb = [data[0], v, data[2]];
          break;
        case 3:
          rgb = [data[0], data[1], v];
          break;
        case 4:
          rgb = [data[2], data[0], v];
          break;
        default:
          rgb = [v, data[0], data[1]];
          break;
      }
    }
    return '#' + rgb.map(function(x){
      return ("0" + Math.round(x*255).toString(16)).slice(-2);
    }).join('');
  };

  render() {
    return (
      <div style={{paddingTop: "35px", width: '100%', height: '100%'}}>
        <div className="map" ref="container" style={{width: '100%', height: '100%'}}/>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/map/mapWidget.jsx